<div
  class="core-ui-document-attachment-card"
  [class.core-ui-document-attachment-card--compact]="variant === 'compact'"
  [class.core-ui-document-attachment-card--message]="variant === 'message'"
  [attr.data-state]="state"
>
  <div class="core-ui-document-attachment-card__main">
    <core-ui-file-type-icon
      [typeLabel]="typeLabel"
      [color]="iconColor"
      [size]="iconSize"
    ></core-ui-file-type-icon>
    <div class="core-ui-document-attachment-card__info">
      <span class="core-ui-document-attachment-card__name" [title]="fileName">{{ displayFileName }}</span>

      <span class="core-ui-document-attachment-card__meta" *ngIf="state === 'completed'">
        {{ typeLabel }} &middot; {{ sizeLabel }}
      </span>

      <span class="core-ui-document-attachment-card__meta" *ngIf="state === 'uploading'">
        {{ typeLabel }} &middot; {{ sizeLabel }}
      </span>

      <span class="core-ui-document-attachment-card__meta core-ui-document-attachment-card__meta--error" *ngIf="state === 'failed'">
        No se pudo subir
      </span>

      <span class="core-ui-document-attachment-card__meta" *ngIf="state === 'cancelled'">
        Cancelado
      </span>

      <span class="core-ui-document-attachment-card__meta core-ui-document-attachment-card__meta--error" *ngIf="state === 'interrupted'">
        Subida interrumpida &middot; {{ clampedProgress }}% subido
      </span>

      <div class="core-ui-document-attachment-card__progress" *ngIf="state === 'uploading'">
        <div class="core-ui-document-attachment-card__progress-track">
          <div class="core-ui-document-attachment-card__progress-fill" [style.width.%]="clampedProgress"></div>
        </div>
        <span class="core-ui-document-attachment-card__progress-label">{{ clampedProgress }}%</span>
      </div>
    </div>
  </div>

  <!--
    Un adjunto ya subido no expone acciones propias: la descarga vive en la
    opción "Descargar" del menú del mensaje y en la pestaña "Archivos". Los
    botones "Abrir"/"Guardar como" que había acá se retiraron porque "Abrir"
    navegaba al endpoint 302 sin `Content-Disposition`, y el navegador solo
    sabe renderizar inline algunos tipos (PDF sí, Word no) — el resultado
    dependía del tipo de archivo en vez de ser una descarga predecible.
  -->
  <div class="core-ui-document-attachment-card__actions" *ngIf="state === 'uploading'">
    <button type="button" class="core-ui-document-attachment-card__action" (click)="onCancel()">
      Cancelar
    </button>
  </div>

  <div class="core-ui-document-attachment-card__actions" *ngIf="state === 'failed'">
    <button type="button" class="core-ui-document-attachment-card__action" (click)="onRetry()">
      Reintentar
    </button>
    <button type="button" class="core-ui-document-attachment-card__action" (click)="onCancel()">
      Cancelar
    </button>
  </div>

  <!--
    'interrupted' es una subida que quedó a medias al recargar la página. El
    navegador no puede persistir el handle del File, así que los bytes ya no
    existen y la subida NO se puede reanudar: ofrecer "Reintentar" acá sería
    una acción que nunca podría funcionar. La única salida es descartar el
    placeholder y volver a adjuntar el archivo.
  -->
  <div class="core-ui-document-attachment-card__actions" *ngIf="state === 'interrupted'">
    <button type="button" class="core-ui-document-attachment-card__action" (click)="onCancel()">
      Descartar
    </button>
  </div>
</div>
